/* SelmaCilek ürün listesi filtreleri — main-collection ve main-search ile yüklenir (defer). Görünüm: assets/sc-filters.css
   - Panel, Impulse'un #FilterDrawer çekmecesidir: açma/kapama, odak tuzağı, Esc ve karartma Impulse'ta kalır.
   - Panelde seçim yapılınca sonuçlar sayfa yenilenmeden gelir (Shopify section rendering); panel açık kalır,
     adetler, "View N items" düğmesi, seçili filtre etiketleri ve ürün ızgarası [data-sc-swap] alanlarıyla yenilenir.
   - Adres filter.* parametreleriyle güncellenir (geri tuşu çalışır). Sıralama da aynı yoldan gelir.
   - JS yoksa: panel ızgaranın üstünde açık durur, form normal GET ile gönderilir; etiketler ve "Clear all" düz bağlantıdır.
   - Yeni kartlar sc-grid.js'in MutationObserver'ı ile yakalanır; Impulse kart işlevleri reinitProductGridItem ile yenilenir. */
(function () {
  'use strict';
  if (window.__scFilters) return;
  window.__scFilters = true;

  var seq = 0, ctrl = null, timer = 0, needTop = false;
  var lastSearch = location.search;

  function plp() { return document.querySelector('[data-sc-plp]'); }
  function fform() { return document.querySelector('[data-sc-filter-form]'); }
  function each(sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); }

  // Formdaki seçimler + formda karşılığı olmayan filtreler (ör. adresle gelen fiyat/stok) korunur
  function formParams(f) {
    var p = new URLSearchParams(), names = {};
    Array.prototype.forEach.call(f.elements, function (el) { if (el.name) names[el.name] = 1; });
    new FormData(f).forEach(function (v, k) { if (v !== '') p.append(k, v); });
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 && !names[k]) p.append(k, v);
    });
    return p;
  }

  function hdr() {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sc-header-h'));
    return isNaN(v) ? 0 : v;
  }

  // Sonuçların başı ekranın üstünde kaldıysa oraya dön (panel açıkken değil; kapanınca)
  function toTop() {
    var t = document.querySelector('[data-sc-top]');
    if (!t) return;
    var y = t.getBoundingClientRect().top + window.pageYOffset - hdr();
    if (window.pageYOffset > y + 2) window.scrollTo(0, Math.max(0, y));
  }

  function syncSort() {
    each('[data-sc-sort]', function (s) {
      var f = s.closest('form'), v = f && f.querySelector('[data-sc-sort-v]');
      if (v && s.selectedIndex > -1) v.textContent = s.options[s.selectedIndex].text;
    });
  }

  function setSortInputs(val) {
    each('[data-sc-sort]', function (s) { if (val) s.value = val; else if (s.getAttribute('data-default')) s.value = s.getAttribute('data-default'); });
    var f = fform();
    if (!f) return;
    var h = f.querySelector('input[name="sort_by"]');
    if (!val) { if (h) h.parentNode.removeChild(h); return; }
    if (!h) {
      h = document.createElement('input');
      h.type = 'hidden';
      h.name = 'sort_by';
      f.insertBefore(h, f.firstChild);
    }
    h.value = val;
  }

  function swap(doc) {
    var open = {};
    each('[data-sc-filter-form] details[data-sc-key]', function (d) { open[d.getAttribute('data-sc-key')] = d.open; });
    var ae = document.activeElement, fid = ae && ae.id;
    each('[data-sc-swap]', function (el) {
      var n = doc.querySelector('[data-sc-swap="' + el.getAttribute('data-sc-swap') + '"]');
      if (n && el.innerHTML !== n.innerHTML) el.innerHTML = n.innerHTML;
    });
    each('[data-sc-filter-form] details[data-sc-key]', function (d) {
      var k = d.getAttribute('data-sc-key');
      if (Object.prototype.hasOwnProperty.call(open, k)) d.open = open[k];
    });
    if (fid && document.activeElement !== ae) {
      var f = document.getElementById(fid);
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
    }
  }

  function done(opt) {
    try { if (window.theme && typeof window.theme.reinitProductGridItem === 'function') window.theme.reinitProductGridItem(); } catch (e) {}
    document.dispatchEvent(new CustomEvent('collection:reloaded'));
    syncSort();
    if (opt.scroll === false) return;
    if (document.documentElement.classList.contains('js-drawer-open')) needTop = true;
    else toTop();
  }

  function render(params, opt) {
    opt = opt || {};
    var root = plp();
    if (!root) return;
    params.delete('section_id');
    var qs = params.toString();
    var url = location.pathname + (qs ? '?' + qs : '');
    var src = location.pathname + '?' + (qs ? qs + '&' : '') + 'section_id=' + encodeURIComponent(root.getAttribute('data-section-id'));
    var my = ++seq;
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    ctrl = window.AbortController ? new AbortController() : null;
    root.classList.add('is-sc-loading');
    root.setAttribute('aria-busy', 'true');
    fetch(src, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (my !== seq) return;
        swap(new DOMParser().parseFromString(html, 'text/html'));
        if (opt.push !== false && url !== location.pathname + location.search) {
          try { history.pushState({ scf: 1 }, '', url); } catch (e) {}
        }
        lastSearch = location.search;
        done(opt);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        if (my === seq) location.href = url; // olmazsa normal sayfa yüklemesi
      })
      .then(function () {
        if (my !== seq) return;
        root.classList.remove('is-sc-loading');
        root.removeAttribute('aria-busy');
      });
  }

  function sortBy(sel) {
    var p = new URLSearchParams(location.search);
    p.set('sort_by', sel.value);
    p.delete('page');
    setSortInputs(sel.value);
    syncSort();
    render(p);
  }

  // Panelde seçim: kısa bekleme (art arda tıklamalar tek istekte), panel açık kalır
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var f = t.closest('[data-sc-filter-form]');
    if (f) {
      clearTimeout(timer);
      timer = setTimeout(function () { timer = 0; render(formParams(f)); }, 180);
      return;
    }
    if (t.matches('[data-sc-sort]')) sortBy(t);
  });

  // "View N items" (submit + js-drawer-close): Impulse paneli kapatır; bekleyen seçim hemen uygulanır
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (f.matches('[data-sc-filter-form]')) {
      e.preventDefault();
      if (timer) { clearTimeout(timer); timer = 0; render(formParams(f)); }
    } else if (f.matches('[data-sc-sort-form]')) {
      e.preventDefault();
      var s = f.querySelector('[data-sc-sort]');
      if (s) sortBy(s);
    }
  });

  // Etiket (×), "Clear all", boş sonuç bağlantıları
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-sc-link]') : null;
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    if (u.origin !== location.origin || u.pathname !== location.pathname) return;
    e.preventDefault();
    u.searchParams.delete('page');
    setSortInputs(u.searchParams.get('sort_by'));
    render(u.searchParams);
  });

  window.addEventListener('popstate', function () {
    if (!plp() || location.search === lastSearch) return;
    var p = new URLSearchParams(location.search);
    setSortInputs(p.get('sort_by'));
    syncSort();
    render(p, { push: false, scroll: false });
  });

  function watchDrawer() {
    var d = document.getElementById('FilterDrawer');
    if (!d || d.__scW || !window.MutationObserver) return;
    d.__scW = true;
    new MutationObserver(function () {
      if (needTop && !d.classList.contains('drawer--is-open')) { needTop = false; toTop(); }
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  // Telefonda yapışkan çubuk için başlık yüksekliği yedeği (sc-header-overlay kapalıysa --sc-header-h olmaz)
  function watchHeader() {
    var sh = document.getElementById('SiteHeader');
    if (!sh || sh.__scfRO || !window.ResizeObserver) return;
    sh.__scfRO = true;
    new ResizeObserver(function () {
      document.documentElement.style.setProperty('--scf-top', sh.offsetHeight + 'px');
    }).observe(sh);
  }

  function init() { syncSort(); watchDrawer(); watchHeader(); lastSearch = location.search; }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
